// Implements: F-MCK-003, F-UIX-009
/**
 * `GET /mockups/{id}`, read ONCE for everything on a mockup's page.
 *
 * The scope selector needs where the mockup lives and the version tree needs
 * which version is current: both come out of this one answer, under the one
 * query key `mockupDetailKey`. It lives in `shared/api` because two modules
 * need it and a module may not reach into another; two queries with their own
 * keys would be two requests on load and two things to remember to invalidate.
 */

import type { MockupDetailView } from "../../types/api";
import { ApiError, UNKNOWN_ERROR_CODE } from "./ApiError";
import { API_BASE } from "./apiBase";
import { httpRequest } from "./httpClient";

export function mockupDetailPath(mockupId: string): string {
  return `${API_BASE}/mockups/${encodeURIComponent(mockupId)}`;
}

export async function fetchMockupDetail(mockupId: string): Promise<MockupDetailView> {
  const body = await httpRequest<MockupDetailView>(mockupDetailPath(mockupId));
  if (body === undefined) {
    throw new ApiError(200, UNKNOWN_ERROR_CODE, "GET /mockups/{id} answered with no body", new Headers());
  }
  return body;
}
